module.exports = __webpack_public_path__ + "static/media/lon_ris_ass_tra.d1eb92fc.png";